import React from 'react'

import NavFeed from '../components/NavFeed'

export default class Feed extends React.Component {
  componentDidMount() {
    document.title = 'Feed'
  }

  render() {
    return (
      <div>
        <NavFeed />
        <section className="container feed">
            <iframe src="http://feed-sergimiral-com.smvi.co/" frameBorder="0"></iframe>
        </section>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/javascripts/pages/Feed.js